import one from "@assets/reactions/1.gif";
import two from "@assets/reactions/2.gif";
import three from "@assets/reactions/3.gif";
import four from "@assets/reactions/4.gif";
import five from "@assets/reactions/5.gif";

export const getReactionGif = (id: string) => {
  switch (id) {
    case "1":
      return one;
    case "2":
      return two;
    case "3":
      return three;
    case "4":
      return four;
    case "5":
      return five;
    default:
      break;
  }
};
